import API from "../lib/api";

export const getUserSettingsApi = async () => {
  try {
    const response = await API.get(`/user-settings`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user settings:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Error fetching user settings.",
    };
  }
};

export const updateVatSettings = async (restaurant_id, data) => {  
  try {
    const response = await API.post(`/restaurant/${restaurant_id}/take-order-settings/vat`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating vat settings:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Error updating vat settings.",
    };
  }
};
export const getTopSellingSettings = async (restaurant_id) => {
  try {
    const response = await API.get(`/restaurant/${restaurant_id}/top-selling-settings`);
    return response.data;
  } catch (error) {
    console.error("Error fetching top selling settings:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Error fetching top selling settings.",
    };
  }
};

export const updateTopSellingDaySettings = async (restaurant_id, data) => {
  try {
    const requestBody = {
      day_id: data?.day_id ?? data?.top_selling_day ?? data,
    };

    const response = await API.put(`/restaurant/${restaurant_id}/top-selling-settings`, requestBody);
    return response.data;
  } catch (error) {
    console.error("Error updating top selling day settings:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Error updating top selling day settings.",
    };
  }
};

export const clearNewArrivalItems = async (restaurant_id) => {
  try {
    const response = await API.post(`/restaurant/${restaurant_id}/take-order/new-arrival-items/clear`);
    return response.data;
  } catch (error) {
    console.error("Error clearing new arrival items:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Error clearing new arrival items.",
    };
  }
};
export const updateCookingTimeSettings = async (restaurant_id, data) => {
  try {
    const response = await API.put(`/restaurant/${restaurant_id}/take-order-settings/cooking-time`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating cooking time settings:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Error updating cooking time settings.",
    };
  }
};